import { render, staticRenderFns } from "./BindCard.vue?vue&type=template&id=719ff760&scoped=true"
import script from "./BindCard.vue?vue&type=script&lang=js"
export * from "./BindCard.vue?vue&type=script&lang=js"
import style0 from "./BindCard.vue?vue&type=style&index=0&id=719ff760&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "719ff760",
  null
  
)

export default component.exports